export default __webpack_public_path__ + "static/media/back-search.c7460c7b.svg";